module.exports = __webpack_public_path__ + "img/win_the_bid.dc91313e.png";